/**
 * @file useTaskActions.js
 * @location src/hooks/useTaskActions.js
 * @role 공통 업무 조작 핸들러 훅 — 완료 토글(검수 폐기 razor ㉓ 이후 단일 핸들러)
 *
 * 사용처: ManagerTasksPage·MemberTasksPage(TeamTaskTable), MemberRoutineCards
 *
 * handleToggle(id)  업무 완료/미완료 토글 (TOGGLE_TASK). 완료 시 onToast 피드백.
 * 권한 razor: 호출 측(컴포넌트)에서 본인 담당(aee) 여부를 가드.
 */
import { useCallback } from 'react';
import { useApp } from '../store/AppContext';
import { STATUS } from '../data/labels.js';
import { notify, EVENTS } from '../integrations/notify';

export function useTaskActions(onToast) {
  const { S, act } = useApp();

  const handleToggle = useCallback((id) => {
    const t = S.tasks.find(t => t.id === id);
    if (!t) return;
    const wasDone = t.status === STATUS.DONE;
    // 핸드셰이크 게이트: 미-인 담당 업무를 완료로 전환하려면 먼저 읽음 처리.
    // (루틴 자동--분 등 acknowledgedAt 없이 도착한 task — TOGGLE_TASK 가 미-이면 무시하므로
    //  완료가 명시적 의사인 이 자리서 자동 읽음 후 토글. ACK_TASK 는 멱등.)
    if (!wasDone && !t.acknowledgedAt) act('ACK_TASK', { id });
    act('TOGGLE_TASK', { id });
    if (!wasDone) {
      notify(EVENTS.TASK_COMPLETED, { taskId: id, byUid: t.aee, toUid: t.aor, title: t.title });
    }
    onToast(wasDone ? '완료를 취소했습니다' : '✓ 업무를 완료했습니다');
  }, [S.tasks, act, onToast]);

  return { handleToggle };
}
